/**
 * Shared constants across the application to avoid circular dependencies
 */

// Route path segments that are publicly accessible without authentication.
// Imported and reused in App.js, AuthValidator.js, axiosInterceptor.js, authSlice.js, AppRoutes.js.
export const PUBLIC_SEGMENTS = ["/live/", "/edit/", "/not-found"];
